import {SERVER_API} from "../utils/info";
import jwt_decode from 'jwt-decode';
import authHeader from "./authHeader";
import getUserData from "./getUserData";

// Authentication with server
export const loginUser = async (username, password) => {
    const res = await fetch(SERVER_API + '/user/auth', {
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
        body: new URLSearchParams({
            username: username,
            password: password,
            grant_type: 'password'
        })
    })
    if (res.ok) {
        const {refresh_token, access_token} = await res.json();

        localStorage.setItem('user', JSON.stringify({
            refreshToken: refresh_token,
            accessToken: access_token,
            userData: jwt_decode(access_token)
        }));
    }
    return res;
};

export const logoutUser = async () => {
    return await fetch(SERVER_API + '/user/logout/' + getUserData().userId, {
        method: 'delete',
        headers: authHeader()
    }).then(() => localStorage.removeItem('user'));
};

// Fetch data from server
export const fetchData = async (type, signal) => await fetch(SERVER_API + '/' + type, {signal}).then(res => res.json());
export const fetchLatest = async (type) => await fetch(SERVER_API + '/' + type + '/latest').then(res => res.json());
export const fetchDetails = async (type, id) => await fetch(SERVER_API + '/' + type + '/' + id).then(res => res.json());

// Add data to database
export const addData = (type, payload) => {
    return fetch(SERVER_API + '/' + type, {
        method: 'post',
        headers: authHeader(true),
        body: JSON.stringify(payload)
    });
};

// Remove data from database
export const deleteData = (type, id) => {
    return fetch(SERVER_API + '/' + type + '/' + id, {
        method: 'delete',
        headers: authHeader()
    });
};
